import styled from 'styled-components';
import { Paper, Typography } from '@mui/material';

export const StyledCard = styled(Paper)`
  padding: 16px 16px 0 16px;
  border-radius: 16px;
  border: 1px solid #e0e4ec;
  height: 100%;
  box-shadow: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  user-select: none; 

  &:hover {
    border-color: #3b82f6; // Change to your primary theme color
    background-color: #f8fafc;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: translateY(0px);
    background-color: #f1f5f9;
  }
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 20px;
`;

export const DashedDivider = styled.div`
  border-top: 1px dashed #e0e4ec;
  margin: 24px 0;
  width: 100%;
`;

export const Label = styled(Typography)`
  color: #94a3b8;
  font-size: 0.75rem !important;
  margin-bottom: 4px !important;
`;

export const Value = styled(Typography)`
  color: #1e293b;
  font-weight: 600 !important;
  font-size: 0.9rem !important;
`;